var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnitedkingdom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_36963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 40C31.0462 40 40.0005 31.0457 40.0005 20C40.0005 8.9543 31.0462 0 20.0005 0C8.95479 0 0.000488281 8.9543 0.000488281 20C0.000488281 31.0457 8.95479 40 20.0005 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13435 7.82379C2.56334 9.86778 1.37873 12.2236 0.688965 14.7829H11.0935L4.13435 7.82379Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3111 14.783C38.6214 12.2238 37.4367 9.8679 35.8657 7.82391L28.9067 14.783H39.3111Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.688965 25.2177C1.37881 27.7769 2.56342 30.1328 4.13436 32.1767L11.0933 25.2177H0.688965Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1764 4.13462C30.1324 2.5636 27.7766 1.37899 25.2173 0.689148V11.0936L32.1764 4.13462Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82373 35.8658C9.86771 37.4368 12.2236 38.6214 14.7828 39.3112V28.9069L7.82373 35.8658Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7827 0.689148C12.2235 1.37899 9.86764 2.5636 7.82373 4.13454L14.7827 11.0935V0.689148Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 39.3112C27.7765 38.6214 30.1324 37.4368 32.1763 35.8658L25.2173 28.9069V39.3112Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9067 25.2177L35.8657 32.1768C37.4367 30.1329 38.6214 27.7769 39.3111 25.2177H28.9067Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8312 17.3913H22.6093H22.6092V0.169297C21.7553 0.058125 20.8846 0 20.0005 0C19.1162 0 18.2457 0.058125 17.3918 0.169297V17.3912V17.3913H0.169785C0.0586133 18.2452 0.000488281 19.1159 0.000488281 20C0.000488281 20.8843 0.0586133 21.7548 0.169785 22.6087H17.3917H17.3917V39.8307C18.2457 39.9419 19.1162 40 20.0005 40C20.8846 40 21.7553 39.942 22.6092 39.8307V22.6088V22.6087H39.8312C39.9424 21.7548 40.0005 20.8843 40.0005 20C40.0005 19.1159 39.9424 18.2452 39.8312 17.3913Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2178 25.2175L34.1425 34.1422C34.5529 33.7319 34.9445 33.3029 35.3181 32.8582L27.6773 25.2175H25.2178V25.2175Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7827 25.2175H14.7825L5.85791 34.1421C6.26822 34.5525 6.69721 34.9441 7.14189 35.3177L14.7827 27.6768V25.2175Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7829 14.7827V14.7826L5.85824 5.85779C5.44777 6.2681 5.05621 6.69708 4.68262 7.14177L12.3235 14.7826H14.7829V14.7827Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2178 14.7828L34.1425 5.85792C33.7322 5.44745 33.3032 5.05589 32.8586 4.68237L25.2178 12.3232V14.7828Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_36963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedkingdom);
export default __webpack_public_path__ + "static/media/unitedkingdom.08ccdfc6e0ca1042c1fa191501f0dfd6.svg";
export { ForwardRef as ReactComponent };